<template>
  <div id="appcontainer">
    <xposi-header></xposi-header>
    <router-view/>
    <xposi-modal></xposi-modal>
    <div v-if="!$store.state.initialised" class="init-blanket">
      <spinner :size="60" :width="6"></spinner>
    </div>
    <cookie-banner></cookie-banner>
    <modal-request
      v-if="showModalRequest"
      @close="closeModalRequest"
      ref="modalRequest"
      ></modal-request>
    <modal-bookshelf
      v-if="showModalBookshelf"
      @close="closeModalBookshelf"
      ref="modalBookshelf"
      ></modal-bookshelf>
    <modal-bookshelf-delete
      v-if="showModalBookshelfDelete"
      @close="closeModalBookshelfDelete"
      ref="modalBookshelfDelete"
      ></modal-bookshelf-delete>
    <modal-bookshelf-sort
      v-if="showModalBookshelfSort"
      @close="closeModalBookshelfSort"
      ref="modalBookshelfSort"
      ></modal-bookshelf-sort>
    <modal-bookshelf-item-add
      v-if="showModalBookshelfItemAdd"
      @close="closeModalBookshelfItemAdd"
      ref="modalBookshelfItemAdd"
      ></modal-bookshelf-item-add>
    <modal-selection-export
      v-if="showModalSelectionExport"
      @close="closeModalSelectionExport"
      ref="modalSelectionExport"
      ></modal-selection-export>
    <modal-leaving-with-results
      v-if="showModalLeavingWithResults"
      @close="closeModalLeavingWithResults"
      ref="modalLeavingWithResults"
      ></modal-leaving-with-results>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Modal from '@/components/Modal'
import Spinner from '@/components/utilities/Spinner'
import ModalRequest from '@/components/modals/ModalRequest'
import ModalBookshelf from '@/components/modals/ModalBookshelf'
import ModalBookshelfDelete from '@/components/modals/ModalBookshelfDelete'
import ModalBookshelfSort from '@/components/modals/ModalBookshelfSort'
import ModalBookshelfItemAdd from '@/components/modals/ModalBookshelfItemAdd'
import ModalSelectionExport from '@/components/modals/ModalSelectionExport'
import ModalLeavingWithResults from '@/components/modals/ModalLeavingWithResults'
import Cookiebanner from '@/components/Cookiebanner.vue'
import { Events } from '@/events'

export default {
  data: () => ({
    showModalRequest: false,
    showModalBookshelf: false,
    showModalBookshelfDelete: false,
    showModalBookshelfSort: false,
    showModalBookshelfItemAdd: false,
    showModalSelectionExport: false,
    showModalLeavingWithResults: false
  }),
  methods: {
    async openModalRequest (publicationInfo) {
      this.showModalRequest = true
      await this.$nextTick()
      if (this.$refs.modalRequest?.load) this.$refs.modalRequest.load(publicationInfo)
    },
    closeModalRequest () {
      this.showModalRequest = false
    },
    async openModalBookshelf (editData) {
      this.showModalBookshelf = true
      await this.$nextTick()
      if (this.$refs.modalBookshelf?.load) this.$refs.modalBookshelf.load(editData)
    },
    closeModalBookshelf () {
      this.showModalBookshelf = false
    },
    async openModalBookshelfDelete (bookshelfData) {
      this.showModalBookshelfDelete = true
      await this.$nextTick()
      if (this.$refs.modalBookshelfDelete?.load) this.$refs.modalBookshelfDelete.load(bookshelfData)
    },
    closeModalBookshelfDelete () {
      this.showModalBookshelfDelete = false
    },
    async openModalBookshelfSort (bookshelfData) {
      this.showModalBookshelfSort = true
      await this.$nextTick()
      if (this.$refs.modalBookshelfSort?.load) this.$refs.modalBookshelfSort.load(bookshelfData)
    },
    closeModalBookshelfSort () {
      this.showModalBookshelfSort = false
    },
    async openModalBookshelfItemAdd (addData) {
      this.showModalBookshelfItemAdd = true
      await this.$nextTick()
      if (this.$refs.modalBookshelfItemAdd?.load) this.$refs.modalBookshelfItemAdd.load(addData)
    },
    closeModalBookshelfItemAdd () {
      this.showModalBookshelfItemAdd = false
    },
    async openModalSelectionExport (exportData) {
      this.showModalSelectionExport = true
      await this.$nextTick()
      if (this.$refs.modalSelectionExport?.load) this.$refs.modalSelectionExport.load(exportData)
    },
    closeModalSelectionExport () {
      this.showModalSelectionExport = false
    },
    async openModalLeavingWithResults (callback) {
      this.showModalLeavingWithResults = true
      await this.$nextTick()
      if (this.$refs.modalLeavingWithResults?.open) this.$refs.modalLeavingWithResults.open(callback)
    },
    closeModalLeavingWithResults () {
      this.showModalLeavingWithResults = false
    }
  },
  components: {
    'xposi-header': Header,
    'xposi-modal': Modal,
    spinner: Spinner,
    'modal-request': ModalRequest,
    'modal-bookshelf': ModalBookshelf,
    'modal-bookshelf-delete': ModalBookshelfDelete,
    'modal-bookshelf-sort': ModalBookshelfSort,
    'modal-bookshelf-item-add': ModalBookshelfItemAdd,
    'modal-selection-export': ModalSelectionExport,
    'modal-leaving-with-results': ModalLeavingWithResults,
    'cookie-banner': Cookiebanner
  },
  mounted () {
    Events.$on('openModalRequest', this.openModalRequest)
    Events.$on('openModalBookshelf', this.openModalBookshelf)
    Events.$on('openModalBookshelfDelete', this.openModalBookshelfDelete)
    Events.$on('openModalBookshelfSort', this.openModalBookshelfSort)
    Events.$on('openModalBookshelfItemAdd', this.openModalBookshelfItemAdd)
    Events.$on('openModalSelectionExport', this.openModalSelectionExport)
    Events.$on('openModalLeavingWithResults', this.openModalLeavingWithResults)
  }
}
</script>

<style lang="scss">
  @import "./assets/css/stylesheet.scss";

  .init-blanket {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    z-index: 100;
  }
</style>
